import { Component } from '@angular/core';
import { BeesFooterComponent } from '../bees-footer/bees-footer.component';
import { BeesHeaderComponent } from '../bees-header/bees-header.component';

@Component({
  selector: 'app-marine-insurance',
  standalone: true,
  imports: [BeesFooterComponent, BeesHeaderComponent],
  templateUrl: './marine-insurance.component.html',
  styleUrl: './marine-insurance.component.scss'
})
export class MarineInsuranceComponent {

}
